import { CredentialCardModal } from 'core/Components';

import { useCredentialCardModalProvider } from './CredentialCardModalFactory';

const CredentialCardModalWrapper = ({ credentialId }: { credentialId: string }) => {
  const { opened, close, openModalById } = useCredentialCardModalProvider({
    id: 'Detail',
  });

  return (
    <CredentialCardModal
      opened={opened}
      onClose={close}
      credentialId={credentialId}
      openRemoveModal={() => openModalById('Remove')}
    />
  );
};

export { CredentialCardModalWrapper };
